import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.policy.simulator');
import { Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import { RegionSelection, RegionSelectionService } from 'src/app/region-selection.service';
import { PolicySimulationStateService } from 'src/app/policy-simulation-state.service';

@Component({
    selector: 'wiz-component-policy-simulator',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.policy.simulator/view.scss */
:host {
  display: block;
  width: 100%;
}

.policy-state-signals {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.policy-state-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 28px;
  border: 1px solid currentColor;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 800;
  white-space: normal;
}

.policy-state-chip.is-success {
  background: #e7f5ec;
  color: #237447;
}

.policy-state-chip.is-pending {
  background: #fff2dc;
  color: #8a4f08;
}

.policy-state-chip.is-blocked {
  background: #eef2f6;
  color: #475569;
}

.policy-state-chip.is-warning {
  background: #fff4e5;
  color: #9a4d00;
}

.policy-state-chip.is-info {
  background: #edf5fb;
  color: #255d85;
}

.policy-state-chip.is-scope {
  background: #f1f5f9;
  color: #526171;
}

.policy-status-common-notice {
  margin-top: 16px;
  border-top: 1px solid #e2e8f0;
  padding-top: 12px;
  color: #255d85;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.5;
}

.policy-status-legend {
  border: 1px solid #d7dde5;
  border-radius: 7px;
  background: #fff;
  padding: 16px 20px;
}

.policy-status-legend summary {
  cursor: pointer;
  color: #2b5d87;
  font-size: 11px;
  font-weight: 800;
}

.policy-status-legend__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.policy-status-legend__grid article {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  padding: 10px;
}

.policy-status-legend__grid code {
  display: block;
  margin-top: 7px;
  overflow-wrap: anywhere;
  color: #334155;
  font-size: 9px;
}

.policy-status-legend__grid p {
  margin-top: 5px;
  color: #66717f;
  font-size: 9px;
  line-height: 1.5;
}

@media (max-width: 640px) {
  .policy-status-legend__grid {
    grid-template-columns: 1fr;
  }
}
.policy-workbench,
.policy-result-panel,
.policy-comparison-panel,
.policy-reference-result {
  border: 1px solid #d7dde5;
  border-radius: 7px;
  background: #fff;
  box-shadow: none;
}

.policy-workbench,
.policy-result-panel {
  padding: 20px;
}

.policy-open-recommendation {
  min-height: 40px;
  border: 1px solid #2b5d87;
  border-radius: 4px;
  background: #2b5d87;
  padding: 0 14px;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
}

.policy-section-label {
  color: #2b5d87;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.policy-coverage {
  min-width: 112px;
  border-left: 2px solid #2b5d87;
  padding: 4px 0 4px 14px;
  text-align: right;
}

.policy-coverage p {
  color: #244f76;
  font-size: 22px;
  font-weight: 800;
}

.policy-coverage span {
  color: #66717f;
  font-size: 10px;
}

.policy-score-summary {
  min-width: 188px;
  border: 1px solid #d7dde5;
  border-radius: 6px;
  padding: 14px 18px;
  text-align: center;
}

.policy-score-summary.is-ready {
  border-top: 3px solid #2b5d87;
  background: #fff;
  color: #172231;
}

.policy-score-summary.is-held {
  border-top: 3px solid #bc7717;
  background: #fffbeb;
  color: #8a5511;
}

.policy-goal-audit {
  border: 1px solid #c9d7e2;
  border-radius: 6px;
  background: #f4f7f9;
  padding: 16px;
}

.policy-fact-grid > div,
.policy-package-row {
  border: 1px solid #d7dde5;
  border-radius: 5px;
  background: #fff;
  padding: 16px;
}

.policy-package-row + .policy-package-row {
  margin-top: 8px;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

.policy-scenario-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(380px, 0.8fr);
  gap: 18px;
  margin-top: 20px;
  align-items: start;
}

.policy-scenario-layout__map,
.policy-scenario-layout__controls {
  min-width: 0;
}

.policy-scenario-layout__controls {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f7f8fa;
  padding: 16px;
}

.policy-weight-panel {
  margin-top: 14px;
  border-top: 1px solid #e2e8f0;
  padding-top: 14px;
}

.policy-weight-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.policy-weight-panel__head p {
  color: #0f172a;
  font-size: 11px;
  font-weight: 800;
}

.policy-weight-panel__head small,
.policy-weight-panel__head em {
  color: #64748b;
  font-size: 9px;
  font-style: normal;
}

.policy-weight-panel__head small {
  display: block;
  margin-top: 3px;
}

.policy-weight-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 11px;
}

.policy-weight-grid .weight-control:last-child {
  grid-column: 1/-1;
}

.policy-scenario-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 14px;
}

.weight-control {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.weight-control strong {
  color: #2b5d87;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

.weight-control input {
  grid-column: 1/-1;
  width: 100%;
  accent-color: #2b5d87;
}

.result-metric {
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #fff;
}

.result-metric p {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.result-metric strong {
  display: block;
  margin-top: 4px;
  color: #0f172a;
  font-size: 16px;
}

.explain-box {
  border: 1px solid #c7d2fe;
  border-radius: 5px;
  background: #f4f7f9;
  padding: 14px 16px;
}

.explain-box summary {
  cursor: pointer;
  color: #244f76;
  font-size: 12px;
  font-weight: 800;
}

.policy-recommendation-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
  border: 1px solid #c9d7e2;
  border-radius: 6px;
  background: #f4f7f9;
  padding: 14px;
}

.policy-recommendation-summary > div {
  min-width: 0;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.82);
  padding: 11px 12px;
}

.policy-recommendation-summary span,
.policy-recommendation-summary strong {
  display: block;
}

.policy-recommendation-summary span {
  color: #2b5d87;
  font-size: 10px;
  font-weight: 800;
}

.policy-recommendation-summary strong {
  margin-top: 5px;
  color: #334155;
  font-size: 11px;
  line-height: 1.6;
}

.policy-recommendation-summary__wide {
  grid-column: 1/-1;
}

.policy-reference-result {
  overflow: hidden;
}

.policy-reference-selection {
  display: grid;
  grid-template-columns: 1fr 1.4fr 1fr 1.4fr auto;
  align-items: center;
  border-bottom: 1px solid #d7dde5;
  background: #fff;
}

.policy-reference-selection > div {
  min-width: 0;
  padding: 14px 16px;
  border-right: 1px solid #e3e7eb;
}

.policy-reference-selection span,
.policy-reference-selection strong {
  display: block;
}

.policy-reference-selection span {
  color: #66717f;
  font-size: 9px;
  font-weight: 800;
}

.policy-reference-selection strong {
  margin-top: 4px;
  overflow: hidden;
  color: #172231;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.policy-reference-status {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  min-height: 26px;
  margin: 0 16px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px !important;
  font-weight: 800;
  white-space: nowrap;
}

.policy-reference-status.is-ready {
  background: #e7f5ec;
  color: #237447;
}

.policy-reference-status.is-held {
  background: #fff2dc;
  color: #a15c0a;
}

.policy-reference-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(280px, 0.75fr);
  gap: 18px;
  padding: 18px;
  background: #f4f6f8;
}

.policy-reference-ranking,
.policy-reference-reason,
.policy-reference-held {
  border: 1px solid #d7dde5;
  border-radius: 5px;
  background: #fff;
}

.policy-reference-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 16px 18px;
  border-bottom: 1px solid #d7dde5;
}

.policy-reference-heading p,
.policy-reference-reason > p:first-child {
  color: #2b5d87;
  font-size: 10px;
  font-weight: 800;
}

.policy-reference-heading h2 {
  margin-top: 4px;
  color: #172231;
  font-size: 15px;
  font-weight: 800;
}

.policy-reference-heading > strong {
  color: #244f76;
  font-size: 22px;
}

.policy-reference-table-wrap {
  overflow-x: auto;
}

.policy-reference-table {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
  color: #334155;
  font-size: 11px;
}

.policy-reference-table th {
  background: #f7f8fa;
  color: #66717f;
  font-size: 10px;
  text-align: left;
}

.policy-reference-table th,
.policy-reference-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #e5e8ec;
}

.policy-reference-table td:first-child,
.policy-reference-table td:last-child {
  color: #244f76;
  font-weight: 800;
}

.policy-reference-table td:nth-child(2) {
  color: #172231;
  font-weight: 700;
}

.policy-reference-criteria {
  margin: 14px 16px 16px;
  border: 1px solid #d7dde5;
  background: #f7f8fa;
  padding: 12px 14px;
  color: #526273;
  font-size: 10px;
  line-height: 1.7;
}

.policy-reference-criteria strong {
  color: #172231;
}

.policy-reference-criteria span {
  display: block;
}

.policy-reference-reason {
  padding: 16px;
}

.policy-reference-reason dl {
  margin-top: 10px;
}

.policy-reference-reason dl > div {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid #e5e8ec;
  font-size: 10px;
}

.policy-reference-reason dt {
  color: #66717f;
  font-weight: 800;
}

.policy-reference-reason dd {
  color: #172231;
  font-weight: 700;
  text-align: right;
}

.policy-reference-disclaimer {
  margin-top: 12px;
  border-top: 1px solid #e5e8ec;
  padding-top: 12px;
  color: #66717f;
  font-size: 9px;
}

.policy-reference-held {
  margin: 18px;
  padding: 18px;
  border-color: #efc98e;
  background: #fffbf3;
  color: #74470d;
}

.policy-reference-held h2 {
  margin-top: 10px;
  color: #6f430d;
  font-size: 16px;
  font-weight: 800;
}

.policy-reference-held p {
  margin-top: 7px;
  font-size: 11px;
  line-height: 1.7;
}

.policy-reference-held dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.policy-reference-held dl > div {
  border: 1px solid #efd9b5;
  background: #fff;
  padding: 10px;
}

.policy-reference-held dt {
  color: #9a671e;
  font-size: 9px;
  font-weight: 800;
}

.policy-reference-held dd {
  margin-top: 4px;
  color: #6f430d;
  font-size: 11px;
  font-weight: 700;
}

.policy-reference-alternatives {
  margin-top: 14px;
  border-top: 1px solid #efd9b5;
  padding-top: 12px;
}

@media (max-width: 640px) {
  .policy-workbench,
  .policy-result-panel {
    padding: 16px;
  }
  .policy-score-summary {
    width: 100%;
  }
  .policy-scenario-layout {
    grid-template-columns: 1fr;
    margin-top: 16px;
  }
  .policy-scenario-layout__controls {
    padding: 14px;
  }
  .policy-weight-grid {
    grid-template-columns: 1fr;
  }
  .policy-weight-grid .weight-control:last-child {
    grid-column: auto;
  }
  .policy-scenario-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .policy-scenario-actions button {
    min-width: 0;
  }
  .policy-recommendation-summary {
    grid-template-columns: 1fr;
  }
  .policy-recommendation-summary__wide {
    grid-column: auto;
  }
  .policy-reference-selection {
    grid-template-columns: 1fr;
  }
  .policy-reference-selection > div {
    border-right: 0;
    border-bottom: 1px solid #e3e7eb;
  }
  .policy-reference-status {
    margin: 12px 16px;
    justify-self: start;
  }
  .policy-reference-layout {
    grid-template-columns: 1fr;
    padding: 12px;
  }
  .policy-reference-held dl {
    grid-template-columns: 1fr;
  }
}
@media (min-width: 641px) and (max-width: 1120px) {
  .policy-scenario-layout {
    grid-template-columns: 1fr;
  }
  .policy-reference-selection {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .policy-reference-status {
    margin: 12px 16px;
    justify-self: start;
  }
  .policy-reference-layout {
    grid-template-columns: 1fr;
  }
}`],
})
export class ComponentPolicySimulatorComponent implements OnInit, OnDestroy {
    @Input() public viewMode: 'simulator' | 'recommendation' = 'simulator';
    public policyConfig: any = {
        meta: null,
        regions: [],
        region_tree: { meta: null, regions: [] },
        region_aliases: {},
        industries: [],
        goals: [],
        default_weights: {}
    };
    public simulatorInput: any = {
        region_id: '',
        industry_code: '',
        goal_key: 'GROWTH_PROMOTION',
        weights: {
            specialization: 3,
            employment: 3,
            growth: 3,
            urgency: 3,
            feasibility: 3
        }
    };
    public simulationResult: any = null;
    public simulationLoading: boolean = false;
    public simulatorError: string = '';
    public scenarios: any[] = [];
    public showScenarioComparison: boolean = false;
    public representativeHandoff: any = null;

    private readonly scenarioStorageKey: string = 'reviewops-policy-scenarios-v1';
    private readonly representativeStorageKey: string = 'reviewops-representative-handoff-v1';
    private selectionSubscription: Subscription | null = null;
    private lastSelectedRegionId: string = '';
    private recalculationTimer: any = null;
    private simulationRequestId: number = 0;

    constructor(@Inject( Service)         public service: Service,@Inject( RegionSelectionService)         public regionSelection: RegionSelectionService,@Inject( PolicySimulationStateService)         public policyState: PolicySimulationStateService,@Inject( Router)         private router: Router,    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.regionSelection.loadTree();
        await this.loadPolicyConfig();
        const restoredPolicyState = this.restorePolicyState(this.viewMode === 'recommendation');
        const hasRepresentativeHandoff = this.viewMode === 'simulator'
            ? this.restoreRepresentativeHandoff()
            : false;
        this.restoreScenarios();
        this.applySharedSelection(this.regionSelection.selection);
        this.lastSelectedRegionId = this.regionSelection.selection?.region_id || '';
        this.selectionSubscription = this.regionSelection.selection$.subscribe(selection => {
            void this.onSharedSelectionChanged(selection);
        });
        if (
            this.viewMode === 'simulator'
            && (hasRepresentativeHandoff || restoredPolicyState || this.regionSelection.selection)
        ) await this.runSimulation();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.selectionSubscription?.unsubscribe();
        if (this.recalculationTimer) clearTimeout(this.recalculationTimer);
        this.simulationRequestId += 1;
    }

    private restoreRepresentativeHandoff() {
        try {
            const saved = window.sessionStorage.getItem(this.representativeStorageKey);
            if (!saved) return false;
            const handoff = JSON.parse(saved);
            window.sessionStorage.removeItem(this.representativeStorageKey);
            const region = this.regionSelection.resolve(handoff.region_id || handoff.region_key || '');
            const industry = this.policyConfig.industries.find((item: any) => item.code === handoff.industry_code);
            if (!region || region.analysis_status !== 'READY' || !industry) return false;
            const goal = this.policyConfig.goals.find((item: any) => item.key === handoff.policy_goal_key);
            this.regionSelection.select(region);
            this.simulatorInput.region_id = region.region_id;
            this.simulatorInput.industry_code = industry.code;
            if (goal) this.simulatorInput.goal_key = goal.key;
            this.representativeHandoff = handoff;
            return true;
        } catch (error) {
            window.sessionStorage.removeItem(this.representativeStorageKey);
            return false;
        }
    }

    public async loadPolicyConfig() {
        try {
            const { code, data } = await wiz.call('config', {
                reference_year: this.regionSelection.referenceYear,
            });
            if (code !== 200 || !data) {
                throw new Error(data?.message || '정책 시뮬레이터 설정을 불러오지 못했습니다.');
            }
            this.policyConfig = data;
            this.simulatorInput.weights = { ...data.default_weights };
            this.applySharedSelection(this.regionSelection.selection);
        } catch (error) {
            this.simulatorError = error?.message || '정책 시뮬레이터 초기화 중 오류가 발생했습니다.';
        }
    }

    public get selectedRegionMasterNode() {
        return this.regionSelection.selection
            ? this.regionSelection.resolve(this.regionSelection.selection.region_id)
            : null;
    }

    public get blockedRegionAttempt() {
        return this.regionSelection.blockedAttempt;
    }

    public regionStatusLabel(status: string) {
        return this.regionSelection.statusLabel(status);
    }

    public get canRunSimulation(): boolean {
        const regionReady = this.regionSelection.selection?.analysis_status === 'READY';
        return !!regionReady && (this.viewMode !== 'recommendation' || !!this.simulatorInput.industry_code);
    }

    public policyBlockedMessage(): string {
        const blocked = this.blockedRegionAttempt;
        if (!blocked) return '';
        return blocked.analysis_status === 'PENDING'
            ? '해당 기초자치단체의 상세 LQ 및 정책시뮬레이션 데이터는 현재 검증·확장 중입니다. 상위 광역자치단체 단위 분석을 이용할 수 있습니다.'
            : '해당 지역은 현재 정책시뮬레이션에 필요한 분석 데이터가 제공되지 않습니다.';
    }

    private restoreScenarios() {
        try {
            const saved = window.sessionStorage.getItem(this.scenarioStorageKey);
            const parsed = saved ? JSON.parse(saved) : [];
            this.scenarios = Array.isArray(parsed)
                ? parsed.filter((item: any) => item?.public_result === true).slice(0, 3)
                : [];
        } catch (error) {
            this.scenarios = [];
        }
    }

    private persistScenarios() {
        window.sessionStorage.setItem(this.scenarioStorageKey, JSON.stringify(this.scenarios.slice(0, 3)));
    }

    public async changeSimulatorField(field: string, event: any) {
        this.simulatorInput[field] = event?.target?.value || '';
        this.simulationResult = null;
        this.representativeHandoff = null;
        this.simulatorError = '';
        await this.service.render();
        this.scheduleSimulation();
    }

    public async changeWeight(field: string, event: any) {
        this.simulatorInput.weights[field] = Number(event?.target?.value);
        this.simulationResult = null;
        this.representativeHandoff = null;
        this.simulatorError = '';
        await this.service.render();
        this.scheduleSimulation();
    }

    public async runSimulation() {
        const selection = this.regionSelection.selection;
        if (!selection || selection.analysis_status !== 'READY') {
            this.simulationResult = null;
            this.simulatorError = '분석 가능한 READY 지역을 선택해 주세요.';
            await this.service.render();
            return;
        }
        if (!this.weightsAreValid(this.simulatorInput.weights)) {
            this.simulationResult = this.inputFailureResult(
                'INVALID_WEIGHT',
                '정책 우선순위 가중치를 확인해 주세요.',
                '정책 우선순위 가중치는 각 항목별로 1~5 범위의 숫자만 입력할 수 있습니다. 특화도·고용규모·성장성·시급성·실현가능성 가중치를 확인한 후 다시 실행해 주세요.'
            );
            this.simulatorError = '';
            this.persistPolicyState();
            await this.service.render();
            return;
        }
        const requestId = ++this.simulationRequestId;
        this.simulationLoading = true;
        this.simulatorError = '';
        await this.service.render();
        try {
            const weights = this.simulatorInput.weights;
            const { code, data } = await wiz.call('simulate', {
                reference_year: this.policyConfig?.meta?.reference_year || this.policyConfig?.meta?.year,
                region_id: selection.region_id,
                parent_region_id: selection.parent_region_id || '',
                industry_code: this.simulatorInput.industry_code,
                goal_key: this.simulatorInput.goal_key,
                weight_specialization: weights.specialization,
                weight_employment: weights.employment,
                weight_growth: weights.growth,
                weight_urgency: weights.urgency,
                weight_feasibility: weights.feasibility
            });
            if (requestId !== this.simulationRequestId) return;
            if (code !== 200 && data?.status_code) {
                this.simulationResult = data;
                return;
            }
            if (code !== 200 || !data) {
                throw new Error(data?.message || '시뮬레이션을 실행하지 못했습니다.');
            }
            this.simulationResult = data;
        } catch (error) {
            if (requestId !== this.simulationRequestId) return;
            this.simulationResult = this.inputFailureResult(
                'SYSTEM_ERROR',
                '정책 시뮬레이션 데이터를 불러오지 못했습니다.',
                '정책 시뮬레이션에 필요한 데이터를 불러오지 못했습니다. 지역·산업 선택값과 데이터 적재 상태를 확인해 주세요. 같은 문제가 반복되면 지역 코드 매핑 또는 API 응답을 점검해야 합니다.'
            );
            this.simulatorError = '';
        } finally {
            if (requestId === this.simulationRequestId) {
                this.simulationLoading = false;
                if (this.simulationResult) this.persistPolicyState();
                await this.service.render();
            }
        }
    }

    public openRecommendationPage() {
        if (!this.isPublicSimulationResult() || !this.regionSelection.selection) return;
        this.persistPolicyState();
        void this.router.navigate(['/policy-recommendation']);
    }

    public async resetSimulator() {
        this.simulatorInput = {
            region_id: this.regionSelection.selection?.region_id || '',
            industry_code: '',
            goal_key: this.policyConfig.default_goal_key || 'GROWTH_PROMOTION',
            weights: { ...(this.policyConfig.default_weights || {}) }
        };
        this.simulationResult = null;
        this.representativeHandoff = null;
        this.simulatorError = '';
        await this.service.render();
        if (this.canRunSimulation) await this.runSimulation();
    }

    public async addScenario() {
        if (!this.isPublicSimulationResult() || this.scenarios.length >= 3) return;
        const result = this.simulationResult;
        const scenario = {
            id: `${Date.now()}-${this.scenarios.length + 1}`,
            region: result.region?.label || '미분석 지역',
            industry: result.industry ? `${result.industry.code} ${result.industry.short_name}` : this.simulatorInput.industry_code,
            goal: result.policy_goal?.label || '정책 목표 확인 불가',
            weights: { ...this.simulatorInput.weights },
            lowi: result.recommended_lowi_type || [],
            nato: result.recommended_nato_instrument || [],
            top_package: result.policy_packages?.[0]?.policy_package_name || '-',
            score: result.overall_priority_score,
            reason: result.recommendation_reason || result.message,
            review_status: result.review_status,
            public_result: true,
        };
        this.scenarios = [...this.scenarios, scenario].slice(0, 3);
        this.persistScenarios();
        await this.service.render();
    }

    public async compareScenarios() {
        this.showScenarioComparison = this.scenarios.length > 0;
        await this.service.render();
    }

    public async removeScenario(index: number) {
        this.scenarios = this.scenarios.filter((_: any, itemIndex: number) => itemIndex !== index);
        this.showScenarioComparison = this.showScenarioComparison && this.scenarios.length > 0;
        this.persistScenarios();
        await this.service.render();
    }

    public formatCount(value: number) {
        if (value === null || value === undefined) return '-';
        return value.toLocaleString('ko-KR');
    }

    public formatLq(value: number) {
        if (value === null || value === undefined) return '-';
        return Number(value).toFixed(2);
    }

    public formatScore(value: number) {
        if (value === null || value === undefined) return '제공하지 않음';
        return Number(value).toFixed(1);
    }

    public holdScoreLabel(): string {
        const labels: Record<string, string> = {
            DATA_PENDING: '성장성 검증 대기',
            RULE_UNRESOLVED: '정책 규칙 미수렴',
            LQ_CONFLICT: '산업구조 해석 필요',
            OUT_OF_SCOPE: '분석 범위 외',
            HIERARCHY_MISMATCH: '행정계층 불일치',
            INVALID_WEIGHT: '가중치 입력 오류',
            SYSTEM_ERROR: '데이터 조회 오류',
        };
        return labels[this.simulationResult?.status_code] || '상세 결과 준비 중';
    }

    public isPublicSimulationResult(): boolean {
        return this.simulationResult?.policy_ready === true
            && Array.isArray(this.simulationResult?.policy_packages)
            && this.simulationResult.policy_packages.length > 0
            && this.simulationResult.overall_priority_score !== null
            && this.simulationResult.overall_priority_score !== undefined;
    }

    public focusSimulatorIndustry() {
        document.getElementById('simulator-industry-select')?.focus();
    }

    public statusLegend(): any[] {
        const statuses = this.policyConfig?.policy_status_registry?.statuses || {};
        return Object.keys(statuses).map(code => ({ code, ...statuses[code] }));
    }

    public formatPercent(value: number) {
        if (value === null || value === undefined) return '해당 지표 미확보';
        return `${Number(value).toFixed(2)}%`;
    }

    public formatWeight(value: number) {
        if (value === null || value === undefined) return '-';
        return `${(Number(value) * 100).toFixed(1)}%`;
    }

    public formatDelta(value: number) {
        if (value === null || value === undefined) return '-';
        const numeric = Number(value);
        return `${numeric > 0 ? '+' : ''}${numeric.toFixed(1)}`;
    }

    public scoreBreakdownRows(): any[] {
        const result = this.simulationResult;
        if (!result?.standardized_component_scores || !result?.normalized_weights) return [];
        const labels: any = {
            specialization: '특화도',
            employment: '산업 규모',
            growth: '성장성',
            urgency: '정책수요 시급성',
            feasibility: '실현가능성',
        };
        return Object.keys(labels).map(key => ({
            key,
            label: labels[key],
            rawScore: result.standardized_component_scores[key],
            inputWeight: result.weights?.[key],
            normalizedWeight: result.normalized_weights[key],
            contribution: result.weighted_contributions?.[key],
        }));
    }

    public readinessLabel(): string {
        return this.simulationResult?.data_readiness?.label || '준비 상태 확인 중';
    }

    public rankChangeText(value: number): string {
        const numeric = Number(value || 0);
        if (numeric > 0) return `기본 대비 ${numeric}계단 상승`;
        if (numeric < 0) return `기본 대비 ${Math.abs(numeric)}계단 하락`;
        return '기본 순위 동일';
    }

    public get activeRepresentativeContext() {
        return this.simulationResult?.representative_context || this.representativeHandoff || null;
    }

    public recommendationReason() {
        const reason = this.simulationResult?.recommendation_reason || this.simulationResult?.message || '';
        const context = this.activeRepresentativeContext;
        if (!context || this.simulationResult?.representative_context) return reason;
        const rank = context.representative_candidate_rank ? `, 후보 순위 ${context.representative_candidate_rank}위` : '';
        const score = context.representative_score === null || context.representative_score === undefined
            ? '대표성 점수 비교 제외'
            : `대표성 점수 ${Number(context.representative_score).toFixed(2)}${rank}`;
        return `${reason} 대표 산업 지역 분석에서는 ${context.region_level}·${context.representative_type}(${score})으로 분류된 점을 함께 검토했습니다.`;
    }

    public scenarioWeightText(weights: any) {
        if (!weights) return '-';
        return `특 ${weights.specialization} · 고 ${weights.employment} · 성 ${weights.growth} · 시 ${weights.urgency} · 실 ${weights.feasibility}`;
    }

    public primaryPolicyType(): string {
        return this.simulationResult?.recommended_lowi_type?.[0] || '-';
    }

    public secondaryPolicyType(): string {
        return this.simulationResult?.recommended_lowi_type?.slice(1).join(' · ') || '없음';
    }

    public policyInstrumentCombination(): string {
        return this.simulationResult?.recommended_nato_instrument?.join(' + ') || '-';
    }

    public policyNeedText(): string {
        const need = this.simulationResult?.pna?.policy_need;
        return Array.isArray(need) ? need.join(' · ') : (need || '정책수요 추가 확인');
    }

    public reviewTitle(): string {
        return '선택한 조합의 정책 분석 결과를 준비 중입니다.';
    }

    public reviewDetail(): string {
        return this.simulationResult?.review_detail
            || this.simulationResult?.message
            || '지역·산업 데이터가 충분하지 않아 상세 결과를 제공하지 않습니다.';
    }

    public reviewMissingData(): string[] {
        return Array.isArray(this.simulationResult?.required_data)
            ? this.simulationResult.required_data
            : Array.isArray(this.simulationResult?.missing_data)
            ? this.simulationResult.missing_data
            : [];
    }

    public reviewRequiredApproval(): string[] {
        return Array.isArray(this.simulationResult?.required_approval)
            ? this.simulationResult.required_approval
            : [];
    }

    public reviewNextActions(): string[] {
        return Array.isArray(this.simulationResult?.next_actions)
            ? this.simulationResult.next_actions
            : [];
    }

    public alternativeAnalysisPaths(): any[] {
        return Array.isArray(this.simulationResult?.alternative_analysis_paths)
            ? this.simulationResult.alternative_analysis_paths
            : [];
    }

    public verifiedIndustryAlternatives(): any[] {
        return Array.isArray(this.simulationResult?.verified_industry_alternatives)
            ? this.simulationResult.verified_industry_alternatives
            : [];
    }

    public verifiedMetropolitanAlternatives(): any[] {
        return Array.isArray(this.simulationResult?.metropolitan_industry_alternatives)
            ? this.simulationResult.metropolitan_industry_alternatives
            : [];
    }

    public canRetryWithAllIndustries(): boolean {
        return this.canRunSimulation
            && !!this.simulatorInput.industry_code
            && ['DATA_PENDING', 'RULE_UNRESOLVED', 'LQ_CONFLICT'].includes(this.simulationResult?.status_code)
            && (
                this.simulationResult?.status_code !== 'DATA_PENDING'
                || this.verifiedIndustryAlternatives().length > 0
            );
    }

    public canRetryWithParentRegion(): boolean {
        const selection = this.regionSelection.selection;
        if (
            this.simulationResult?.status_code !== 'DATA_PENDING'
            || selection?.region_type !== 'BASIC'
            || !selection.parent_region_id
        ) return false;
        return this.regionSelection.resolve(selection.parent_region_id)?.analysis_status === 'READY';
    }

    public async retryWithAllIndustries() {
        if (!this.canRetryWithAllIndustries()) return;
        this.simulatorInput.industry_code = '';
        this.simulationResult = null;
        this.simulatorError = '';
        await this.service.render();
        await this.runSimulation();
    }

    public async retryWithVerifiedIndustry(industryCode: string) {
        if (!this.canRunSimulation || !industryCode) return;
        this.simulatorInput.industry_code = industryCode;
        this.simulationResult = null;
        this.simulatorError = '';
        await this.service.render();
        await this.runSimulation();
    }

    public retryWithParentRegion() {
        if (!this.canRetryWithParentRegion()) return;
        const parentRegionId = this.regionSelection.selection?.parent_region_id || '';
        const parent = this.regionSelection.resolve(parentRegionId);
        if (parent) this.regionSelection.select(parent);
    }

    private weightsAreValid(weights: any): boolean {
        const keys = ['specialization', 'employment', 'growth', 'urgency', 'feasibility'];
        return keys.every(key => Number.isInteger(Number(weights?.[key])) && Number(weights[key]) >= 1 && Number(weights[key]) <= 5);
    }

    private inputFailureResult(statusCode: string, title: string, detail: string): any {
        const selection = this.regionSelection.selection;
        const industry = this.policyConfig.industries.find((item: any) => item.code === this.simulatorInput.industry_code);
        return {
            status_code: statusCode,
            hold_code: statusCode === 'INVALID_WEIGHT' ? 'RULE_INPUT_MISSING' : 'DATA_PENDING',
            hold_reason: detail,
            review_reason_code: statusCode,
            review_status: '추가 검토 필요',
            availability_status: statusCode === 'INVALID_WEIGHT' ? '입력값 오류' : '시스템 오류',
            review_title: title,
            review_detail: detail,
            message: detail,
            region: selection ? {
                region_id: selection.region_id,
                label: selection.region_name,
                region_type: selection.region_type,
                parent_region_id: selection.parent_region_id,
                analysis_status: selection.analysis_status,
            } : null,
            industry: industry || {
                code: this.simulatorInput.industry_code,
                name: '산업 매핑 미확인',
                short_name: '산업 매핑 미확인',
            },
            policy_goal: this.policyConfig.goals.find((item: any) => item.key === this.simulatorInput.goal_key) || null,
            goal_default_applied: false,
            missing_data: [],
            next_actions: statusCode === 'INVALID_WEIGHT'
                ? ['가중치를 1~5 정수로 수정한 뒤 다시 실행해 주세요.']
                : ['지역·산업 선택값, 데이터 적재 상태와 API 응답 로그를 점검해 주세요.'],
            overall_priority_score: null,
            policy_packages: [],
            lq_ready: false,
            policy_ready: false,
            data_readiness: {
                lq_ready: false,
                policy_ready: false,
                label: '분석 데이터 부족',
                missing_data: [],
            },
        };
    }

    public primaryDataLimitation(): string {
        return this.simulationResult?.limitations?.[0] || '데이터 한계 정보 미제공';
    }

    public recommendationRows(): any[] {
        return Array.isArray(this.simulationResult?.policy_packages)
            ? this.simulationResult.policy_packages.slice(0, 3)
            : [];
    }

    public packageName(item: any): string {
        return item?.policy_package_name || item?.package_name || '정책 패키지명 확인 필요';
    }

    public packageLowi(item: any): string {
        const value = item?.lowi_type;
        return Array.isArray(value) ? value.join(' · ') : (value || this.primaryPolicyType());
    }

    public packageNato(item: any): string {
        const value = item?.nato_instrument || item?.nato_instruments;
        return Array.isArray(value) ? value.join(' · ') : (value || this.policyInstrumentCombination());
    }

    public packageScore(item: any): number | null {
        const value = item?.overall_priority_score ?? item?.final_score;
        return value === null || value === undefined ? null : Number(value);
    }

    private restorePolicyState(includeResult: boolean): boolean {
        const state = this.policyState.read();
        if (!state?.input?.region_id) return false;
        const region = this.regionSelection.resolve(state.input.region_id);
        if (!region || region.analysis_status !== 'READY') return false;
        const industryCode = state.input.industry_code || '';
        if (industryCode && !this.policyConfig.industries.some((item: any) => item.code === industryCode)) {
            return false;
        }
        this.regionSelection.select(region);
        this.simulatorInput = {
            region_id: region.region_id,
            industry_code: industryCode,
            goal_key: this.policyConfig.goals.some((item: any) => item.key === state.input.goal_key)
                ? state.input.goal_key
                : (this.policyConfig.default_goal_key || 'GROWTH_PROMOTION'),
            weights: this.weightsAreValid(state.input.weights)
                ? { ...state.input.weights }
                : { ...this.policyConfig.default_weights },
        };
        if (includeResult && state.result) this.simulationResult = state.result;
        return true;
    }

    private persistPolicyState() {
        const selection = this.regionSelection.selection;
        const industry = this.policyConfig.industries.find(
            (item: any) => item.code === this.simulatorInput.industry_code
        );
        this.policyState.save(
            selection,
            {
                region_id: this.simulatorInput.region_id,
                region_name: selection?.region_name || '',
                region_type: selection?.region_type || '',
                parent_region_id: selection?.parent_region_id || null,
                industry_code: this.simulatorInput.industry_code,
                industry_name: industry?.name || '',
                goal_key: this.simulatorInput.goal_key,
                policy_goal: this.simulatorInput.goal_key,
                weights: { ...this.simulatorInput.weights },
                data_year: this.policyConfig.meta?.reference_year || this.policyConfig.meta?.year || null,
            },
            this.simulationResult,
        );
    }

    private applySharedSelection(selection: RegionSelection | null) {
        this.simulatorInput.region_id = selection?.region_id || '';
    }

    private scheduleSimulation() {
        if (this.recalculationTimer) clearTimeout(this.recalculationTimer);
        if (!this.canRunSimulation || !this.weightsAreValid(this.simulatorInput.weights)) return;
        this.recalculationTimer = setTimeout(() => {
            this.recalculationTimer = null;
            void this.runSimulation();
        }, 250);
    }

    private async onSharedSelectionChanged(selection: RegionSelection | null) {
        const nextRegionId = selection?.region_id || '';
        this.applySharedSelection(selection);
        if (nextRegionId === this.lastSelectedRegionId) {
            await this.service.render();
            return;
        }

        if (this.recalculationTimer) {
            clearTimeout(this.recalculationTimer);
            this.recalculationTimer = null;
        }

        this.lastSelectedRegionId = nextRegionId;
        this.representativeHandoff = null;
        this.simulatorError = '';
        if (!selection) {
            this.simulationResult = null;
            await this.service.render();
            return;
        }
        if (selection.analysis_status !== 'READY') {
            await this.service.render();
            return;
        }

        this.simulationResult = null;
        await this.service.render();
        await this.runSimulation();
    }
}

export default ComponentPolicySimulatorComponent;